import {
  AppDeepLink,
  VanarChainExplorerUrl,
  VanarChainId,
  VanarChainName,
  VanarChainRpcUrl,
} from "./constants";

export const walletImgLoad = (walletName) => {
  switch (walletName) {
    case "metaMaskSDK":
      return process.env.REACT_APP_S3_ASSETS_URL + "metamask.svg";
    case "walletConnect":
      return process.env.REACT_APP_S3_ASSETS_URL + "connectWallet.svg";
    case "coinbaseWalletSDK":
      return process.env.REACT_APP_S3_ASSETS_URL + "coinbase.svg";
    default:
      return process.env.REACT_APP_S3_ASSETS_URL + "metamask.svg";
  }
};

export const handleDeepLink = () => {
  const a = document.createElement("a");
  a.href = process.env.REACT_APP_DEEP_LINK;
  a.click();
};

export const getTruncatedAddress = (str) => {
  if (str && str !== "") {
    return str?.slice(0, 5) + str?.slice(-8).replace(/.(?=...)/g, "*");
  }
  return "";
};

export const addNetwork = async () => {
  let provider = null;
  if (window.ethereum?.providers) {
    provider = window.ethereum?.providers?.find((p) => p?.isMetaMask);
  } else if (window.ethereum?.isMetaMask) {
    provider = window.ethereum;
  }

  if (provider) {
    if (provider.networkVersion !== parseInt(VanarChainId)) {
      const hexadecimalChainId = "0x" + parseInt(VanarChainId).toString(16);
      try {
        await provider.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: hexadecimalChainId }],
        });
      } catch (error) {
        // const errorObj = getErrorObj(error);
        const code = error?.code;
        // This error code indicates that the chain has not been added to Wallet.
        if (code === 4902 || code === -32603) {
          const params = [
            {
              chainId: hexadecimalChainId,
              chainName: VanarChainName,
              nativeCurrency: {
                name: VanarChainName,
                symbol: "VANRY",
                decimals: 18,
              },
              rpcUrls: [VanarChainRpcUrl],
              blockExplorerUrls: [VanarChainExplorerUrl],
            },
          ];
          // in wagmi types for wallet_addEthereumChain method is not provided
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          await provider.request({
            method: "wallet_addEthereumChain",
            params: params,
          });
        }
      }
    } else {
      alert("Network already added in your wallet");
    }
  } else {
    const a = document.createElement("a");
    a.href = AppDeepLink;
    a.click();
  }
};

export const addChain = async () => {
  try {
    const hexadecimalChainId = "0x" + VanarChainId.toString(16);

    if (!window.ethereum) {
      window.open(
        `https://metamask.app.link/dapp/${window.location.host}/add-chain`
      );
      throw new Error("Ethereum provider is not available");
    }

    await window.ethereum.request({
      method: "wallet_addEthereumChain",
      params: [
        {
          chainId: hexadecimalChainId,
          chainName: VanarChainName,
          rpcUrls: [VanarChainRpcUrl],
          nativeCurrency: {
            name: "VANRY",
            symbol: "VANRY",
            decimals: 18,
          },
          blockExplorerUrls: [VanarChainExplorerUrl],
        },
      ],
    });
  } catch (error) {
    console.error("Error adding chain:", error);
  }
};

export const isMobile = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
};
